// JobList.js
import React, { useEffect, useState } from "react";
import Layout from "../../layouts/default";
import { Button, Modal, Form, Table, Spinner, Row, Col, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllVendors, getVendorAccounts } from "../../store/slices/vendors/vendors";
import { createJob, fetchJobs, updateJob, deleteJob } from "../../store/slices/jobs";
import Select from "react-select";
import SmartPagination from "../Report/EmailCampaignRunReport/DynamicSmartPagination";
import { ICONS } from "../../constants/icons";
import Classes from "../Template/style.module.css"; // reuse same CSS module
import { format } from "date-fns";
import { hasPermission } from "../../services/utils";
import { PERMISSIONS } from "../../contants/permission";

function JobList() {
    const dispatch = useDispatch();
    const { vendors, vendorAccounts, loading: vendorLoading } = useSelector(
        (store) => store.vendorReducer
    );
    const { jobs } = useSelector((store) => store.jobReducer);

    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [jobForm, setJobForm] = useState({
        job_id: "",
        job_name: "",
        job_max_try: "",
    });
    const [editingJob, setEditingJob] = useState(null);
    const [editForm, setEditForm] = useState({
        job_id: "",
        job_name: "",
        account_id: "",
        job_max_try: "",
    });


    const [editSelectedVendor, setEditSelectedVendor] = useState(null);
    const [editSelectedAccount, setEditSelectedAccount] = useState(null);
    const [editVendorAccounts, setEditVendorAccounts] = useState([]);

    // Filters
    const [filters, setFilters] = useState({
        job_id: "",
        job_name: "",
        account_id: "",
    });

    const [appliedFilters, setAppliedFilters] = useState({});
    const [page, setPage] = useState(1);
    const limit = 5;

    // Fetch vendors on mount
    useEffect(() => {
        dispatch(fetchAllVendors());
    }, [dispatch]);

    // Fetch accounts when vendor changes (modal only)
    useEffect(() => {
        if (selectedVendor?.value) {
            dispatch(getVendorAccounts({ vendorId: selectedVendor.value }));
            setSelectedAccount(null);
        }
    }, [selectedVendor, dispatch]);

    // Fetch jobs on load and whenever page or filters are applied
    useEffect(() => {
        const payload = {
            page,
            limit,
            filters: {
                ...appliedFilters
            }
        };

        console.log("Fetching jobs with payload:", payload);
        dispatch(fetchJobs(payload));
    }, [dispatch, page, limit, appliedFilters]);

    const handleInputChange = (e) => {
        setJobForm({ ...jobForm, [e.target.name]: e.target.value });
    };

    const handleEditInputChange = (e) => {
        setEditForm({ ...editForm, [e.target.name]: e.target.value });
    };

    const handleSubmitJob = (e) => {
        e.preventDefault();

        if (!selectedVendor) return alert("Please select a vendor.");
        if (!selectedAccount) return alert("Please select a vendor account.");
        if (!jobForm.job_id || !jobForm.job_name || !jobForm.job_max_try)
            return alert("Please enter Job ID, Job Name or Job Max Try.");

        const user = JSON.parse(localStorage.getItem("user"));
        const userId = user?.data?.id;
        if (!userId) return alert("Invalid user");

        const payload = {
            job_id: Number(jobForm.job_id),
            job_name: jobForm.job_name.trim(),
            job_max_try: Number(jobForm.job_max_try),
            account_id: selectedAccount.value,
            created_by: userId,
        };

        dispatch(createJob(payload)).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                setShowModal(false);
                setJobForm({ job_id: "", job_name: "", job_max_try: "" });
                setSelectedVendor(null);
                setSelectedAccount(null);
                setPage(1);
                dispatch(fetchJobs({ page: 1, limit, ...appliedFilters }));
            }
        });
    };

    const handleEditJob = async (job) => {
        setEditingJob(job);
        setEditForm({
            job_id: job.job_id?.toString() || "",
            job_name: job.job_name || "",
            account_id: job.account_id?.toString() || "",
            job_max_try: job.job_max_try?.toString() || "",
        });

        console.log("Editing Job:", job);
        console.log("All Vendors:", vendors);

        const vendorForAccount = vendors.find(v => v.name === 'Hodublast');

        console.log("Vendor for Account:", vendorForAccount);

        if (vendorForAccount) {
            const vendorOption = {
                value: vendorForAccount.id,
                label: vendorForAccount.name,
            };
            setEditSelectedVendor(vendorOption);

            const result = await dispatch(getVendorAccounts({ vendorId: vendorForAccount.id }));

            if (result.meta.requestStatus === "fulfilled") {
                const accounts = result.payload || [];
                setEditVendorAccounts(accounts);

                const account = accounts.find(acc => acc.id === job.account_id);
                if (account) {
                    setEditSelectedAccount({
                        value: account.id,
                        label: account.name,
                    });
                }
            }
        } else {
            setEditSelectedVendor(null);
            setEditSelectedAccount(null);
            setEditVendorAccounts([]);
        }
        setShowEditModal(true);
    };


    // Handle vendor change in edit modal
    const handleEditVendorChange = async (selectedOption) => {
        setEditSelectedVendor(selectedOption);
        setEditSelectedAccount(null);

        if (selectedOption?.value) {
            const result = await dispatch(getVendorAccounts({ vendorId: selectedOption.value }));
            if (result.meta.requestStatus === "fulfilled") {
                setEditVendorAccounts(result.payload || []);
            }
        } else {
            setEditVendorAccounts([]);
        }
    };

    const handleUpdateJob = (e) => {
        e.preventDefault();

        if (!editForm.job_id || !editForm.job_name || !editSelectedAccount || !editForm.job_max_try)
            return alert("Please fill all fields.");

        const payload = {
            id: editingJob.id,
            valuesToUpdate: {
                job_id: Number(editForm.job_id),
                job_name: editForm.job_name.trim(),
                account_id: editSelectedAccount.value,
                job_max_try: editForm.job_max_try
            }
        };

        dispatch(updateJob(payload)).then((res) => {
            if (res.meta.requestStatus === "fulfilled") {
                setShowEditModal(false);
                setEditingJob(null);
                setEditForm({ job_id: "", job_name: "", account_id: "", job_max_try: "" });
                setEditSelectedVendor(null);
                setEditSelectedAccount(null);
                setEditVendorAccounts([]);
                dispatch(fetchJobs({ page, limit, ...appliedFilters }));
            }
        });
    };

    const handleDeleteJob = (jobId) => {
        if (window.confirm("Are you sure you want to delete this job?")) {
            const payload = { id: jobId };

            dispatch(deleteJob(payload)).then((res) => {
                if (res.meta.requestStatus === "fulfilled") {
                    // If we're on the last page and deleting the last item, go to previous page
                    if (jobs.data.length === 1 && page > 1) {
                        setPage(page - 1);
                    } else {
                        dispatch(fetchJobs({ page, limit, ...appliedFilters }));
                    }
                }
            });
        }
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setEditingJob(null);
        setEditForm({ job_id: "", job_name: "", account_id: "", job_max_try: "" });
        setEditSelectedVendor(null);
        setEditSelectedAccount(null);
        setEditVendorAccounts([]);
    };

    // Dropdown options
    const vendorOptions =
        Array.isArray(vendors) && vendors.length > 0
            ? vendors.map((v) => ({ value: v.id, label: v.name }))
            : [];

    const accountOptions =
        Array.isArray(vendorAccounts) && vendorAccounts.length > 0
            ? vendorAccounts.map((acc) => ({ value: acc.id, label: acc.name }))
            : [];

    // Edit modal के लिए account options
    const editAccountOptions =
        Array.isArray(editVendorAccounts) && editVendorAccounts.length > 0
            ? editVendorAccounts.map((acc) => ({ value: acc.id, label: acc.name }))
            : [];

    // Account filter dropdown (from job list)
    const uniqueAccounts =
        Array.isArray(jobs?.data)
            ? [
                ...new Map(
                    jobs.data
                        .filter((j) => j.account?.id && j.account?.name)
                        .map((j) => [j.account.id, { value: j.account.id, label: j.account.name }])
                ).values(),
            ]
            : [];

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleAccountFilter = (selected) => {
        setFilters((prev) => ({ ...prev, account_id: selected?.value || "" }));
    };

    const handleApplyFilters = () => {
        setAppliedFilters(filters);
        setPage(1);
    };

    const handleClearFilters = () => {
        const cleared = { job_id: "", job_name: "", account_id: "" };
        setFilters(cleared);
        setAppliedFilters({});
        setPage(1);
    };

    return (
        <Layout>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fw-semibold mb-0">Job List</h4>
                {
                    hasPermission(PERMISSIONS.JOB_LIST.CREATE) && <Button variant="primary" onClick={() => setShowModal(true)}>
                        + Add Job
                    </Button>
                }
            </div>

            {/* Filters Section */}
            <div className="mb-3 p-3 border rounded bg-light">
                <Row className="align-items-end g-2">
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Job ID</Form.Label>
                            <Form.Control
                                type="text"
                                name="job_id"
                                value={filters.job_id}
                                placeholder="Search by Job ID"
                                onChange={handleFilterChange}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Job Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="job_name"
                                value={filters.job_name}
                                placeholder="Search by Job Name"
                                onChange={handleFilterChange}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Account</Form.Label>
                            <Select
                                options={uniqueAccounts}
                                value={
                                    uniqueAccounts.find((a) => a.value === filters.account_id) || null
                                }
                                onChange={handleAccountFilter}
                                placeholder="Filter by Account"
                                isClearable
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3} className="text-end">
                        <Button
                            variant="primary"
                            className="me-2"
                            onClick={handleApplyFilters}
                        >
                            Apply Filters
                        </Button>
                        <Button variant="secondary" onClick={handleClearFilters}>
                            Clear
                        </Button>
                    </Col>
                </Row>
            </div>

            {/* Job Table */}
            {jobs.loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-2">Loading jobs...</p>
                </div>
            ) : jobs.data.length > 0 ? (
                <>
                    <Table className="striped bordered hover">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Job ID</th>
                                <th>Job Name</th>
                                <th>Job Max Try</th>
                                <th>Account</th>
                                <th>Created On</th>
                                {
                                    (hasPermission(PERMISSIONS.JOB_LIST.EDIT) || hasPermission(PERMISSIONS.JOB_LIST.DELETE)) && <th>Action</th>
                                }
                            </tr>
                        </thead>

                        <tbody>
                            {jobs?.data?.length ? (
                                jobs.data.map((job, index) => (
                                    <tr key={job.id || index}>
                                        <td>{(page - 1) * limit + (index + 1)}</td>
                                        <td>{job.job_id}</td>
                                        <td>{job.job_name}</td>
                                        <td>{job.job_max_try}</td>
                                        <td>{job?.account?.name || "NA"}</td>
                                        <td>{format(new Date(job.created_at), "yyyy-MM-dd")}</td>

                                        <td className={Classes.actions}>
                                            {
                                                hasPermission(PERMISSIONS.JOB_LIST.EDIT) && <span
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleEditJob(job)}
                                                >
                                                    <img src={ICONS.edit_action} alt="Edit" />
                                                </span>
                                            }
                                            &nbsp;&nbsp;&nbsp;

                                            {
                                                hasPermission(PERMISSIONS.JOB_LIST.DELETE) && <span
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() =>
                                                        handleDeleteJob(job.id)
                                                    }
                                                >
                                                    <img src={ICONS.delete_action} alt="Delete" />
                                                </span>
                                            }
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6}>No jobs found!!</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>


                    <SmartPagination
                        currentPage={page}
                        totalPages={jobs.pagination?.totalPages || 0}
                        onPageChange={(newPage) => setPage(newPage)}
                    />
                </>
            ) : (
                <p className="text-center text-muted py-4">No jobs found.</p>
            )}

            {/* Modal for Adding Job */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>Add New Job</Modal.Title>
                </Modal.Header>

                <Form onSubmit={handleSubmitJob}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Vendor</Form.Label>
                            <Select
                                options={vendorOptions}
                                value={selectedVendor}
                                onChange={setSelectedVendor}
                                placeholder={vendorLoading ? "Loading vendors..." : "Select a vendor"}
                                isDisabled={vendorLoading || vendorOptions.length === 0}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Select Account</Form.Label>
                            <Select
                                options={accountOptions}
                                value={selectedAccount}
                                onChange={setSelectedAccount}
                                placeholder={
                                    selectedVendor
                                        ? vendorLoading
                                            ? "Loading accounts..."
                                            : "Select an account"
                                        : "Select a vendor first"
                                }
                                isDisabled={!selectedVendor || vendorLoading}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job ID</Form.Label>
                            <Form.Control
                                type="text"
                                name="job_id"
                                placeholder="Enter Job ID"
                                value={jobForm.job_id}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job Max Try</Form.Label>
                            <Form.Control
                                type="text"
                                name="job_max_try"
                                placeholder="Enter Job Max Try"
                                value={jobForm.job_max_try}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="job_name"
                                placeholder="Enter Job Name"
                                value={jobForm.job_name}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Modal for Editing Job */}
            <Modal show={showEditModal} onHide={handleCloseEditModal} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Job</Modal.Title>
                </Modal.Header>

                <Form onSubmit={handleUpdateJob}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Vendor</Form.Label>
                            <Select
                                options={vendorOptions}
                                value={editSelectedVendor}
                                onChange={handleEditVendorChange}
                                placeholder={vendorLoading ? "Loading vendors..." : "Select a vendor"}
                                isDisabled={vendorLoading || vendorOptions.length === 0}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Select Account</Form.Label>
                            <Select
                                options={editAccountOptions}
                                value={editSelectedAccount}
                                onChange={setEditSelectedAccount}
                                placeholder={
                                    editSelectedVendor
                                        ? "Select an account"
                                        : "Select a vendor first"
                                }
                                isDisabled={!editSelectedVendor}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job ID</Form.Label>
                            <Form.Control
                                type="text"
                                name="job_id"
                                placeholder="Enter Job ID"
                                value={editForm.job_id}
                                onChange={handleEditInputChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job Max Try</Form.Label>
                            <Form.Control
                                type="text"
                                name="job_max_try"
                                placeholder="Enter Job Max Try"
                                value={editForm.job_max_try}
                                onChange={handleEditInputChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Job Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="job_name"
                                placeholder="Enter Job Name"
                                value={editForm.job_name}
                                onChange={handleEditInputChange}
                                required
                            />
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseEditModal}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Update Job
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </Layout>
    );
}

export default JobList;